// extracted by mini-css-extract-plugin
export default {"infoCard":"InfoCard_infoCard__wN0zM","photo":"InfoCard_photo__hnW7r","text":"InfoCard_text__SqlHk","subtitle":"InfoCard_subtitle__worbZ","title":"InfoCard_title__rznhp"};